import { useContext, useEffect, useRef, useState } from 'react';
import { AuthContext } from '../../../components/contexts/AuthContext';
import { catalogueCode, catalogueFailure, createRequest, getRequest, requestBody } from '../models/cataloguePhase2Model';
export function useMissingCatalogueRequest(kind, anchors = {}, onRequested) {
  const [state, setState] = useState({}), flight = useRef(false), active = useRef(true), saved = useRef(null);
  const actor = useContext(AuthContext)?.authState?.id;
  const generation = useRef(0);
  useEffect(() => { active.current = true; saved.current = null; setState({}); return () => { active.current = false; generation.current += 1; }; }, [kind, anchors.make_id, anchors.query_pk, anchors.query_part_id, actor]);
  const post = async (body, join = false) => {
    const run = generation.current;
    try {
      const row = await createRequest(body);
      if (active.current && run === generation.current) { setState({ row }); onRequested?.(row); }
      return row;
    } catch (error) {
      if (active.current && run === generation.current) {
        const detail = error.response?.data?.data || error.data;
        setState({ error: catalogueFailure(error), joinId: !join && catalogueCode(error) === 'CATALOGUE_REQUEST_EXISTS' ? detail?.request_id : null });
      }
      return null;
    }
  };
  const start = async (text, addLegacy) => {
    if (flight.current) return;
    flight.current = true; setState({ busy: true });
    const run = generation.current;
    try {
      // Legacy creation is not repeated when only the admin request needs recovery.
      const added = await addLegacy?.(text);
      if (!active.current || run !== generation.current) return;
      if (added === false) throw new Error('The temporary name could not be saved.');
      saved.current = requestBody(kind, text, anchors);
      await post(saved.current);
    } catch (error) { if (active.current) setState({ error: catalogueFailure(error) }); }
    finally { flight.current = false; }
  };
  const retry = async () => {
    if (flight.current || !saved.current) return;
    flight.current = true; const joinId = state.joinId; setState({ busy: true });
    try {
      let body = saved.current;
      if (joinId) { const latest = await getRequest(joinId); body = { ...body, expected_version: latest.version }; }
      await post(body, !!joinId);
    } catch (error) { if (active.current) setState({ error: catalogueFailure(error) }); }
    finally { flight.current = false; }
  };
  return { ...state, start, retry };
}
